import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSettingsComponent } from 'src/app/_core/components/user-settings/user-settings.component';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UsernameConfirmationHintModule } from 'src/app/users/components/username-confirmation-hint/username-confirmation-hint.module';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [UserSettingsComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    RouterModule,
    HttpClientModule,
    MatSnackBarModule,
    UsernameConfirmationHintModule,
    MatCardModule,
  ],
})
export class UserSettingsModule {}
